export default {
  settings: {
    currentLogo: "Current logo",
    logo: "Logo",
    paginationSize: "Pagination size",
    paginationHint: "Number of items displayed per page.",
    notify:{
      errorFetchText: "Unable to load settings",
      sucessSaveText: "Saved settings",
      errorSaveText:"Error during backup",
    }
  }
}
